import axios from '@/libs/api.request'

// 文章分类
export const apiArticleCategoryList = data => {
  return axios.request({
    url: '/admin/article-category',
    method: 'get',
    data,
  })
}
// 文章分类不分页
export const apiArticleCategoryListNoPage = data => {
  return axios.request({
    url: '/admin/article-category/all-list',
    method: 'get',
    data,
  })
}
// 分类详情
export const apiArticleCategoryDetail = (id,data) => {
  return axios.request({
    url: `/admin/article-category/${id}`,
    method: 'get',
    data,
  })
}
// 新增分类
export const apiArticleCategoryAdd = data => {
  return axios.request({
    url: '/admin/article-category',
    method: 'post',
    data,
  })
}
// 编辑分类
export const apiArticleCategoryEdit = (id,data) => {
  return axios.request({
    url: `/admin/article-category/${id}`,
    method: 'put',
    data,
  })
}
// 删除分类
export const apiArticleCategoryDetele = (id,data) => {
  return axios.request({
    url: `/admin/article-category/${id}`,
    method: 'delete',
    data,
  })
}

// 文章列表
export const apiArticleList = data => {
  return axios.request({
    url: '/admin/article',
    method: 'get',
    data,
  })
}
// 文章列表不分页
export const apiArticleListNoPage = data => {
  return axios.request({
    url: '/admin/article-category-all',
    method: 'get',
    data,
  })
}
// 详情
export const apiArticleDetail = (id,data) => {
  return axios.request({
    url: `/admin/article/${id}`,
    method: 'get',
    data,
  })
}
// 新增
export const apiArticleAdd = data => {
  return axios.request({
    url: '/admin/article',
    method: 'post',
    data,
  })
}
// 编辑
export const apiArticleEdit = (id,data) => {
  return axios.request({
    url: `/admin/article/${id}`,
    method: 'put',
    data,
  })
}
// 删除
export const apiArticleDetele = (id,data) => {
  return axios.request({
    url: `/admin/article/${id}`,
    method: 'delete',
    data,
  })
}